import MedicineClientCheckList from "./MedicineClient-check-list/MedicineClientCheckList.vue";
import i18n from "../../i18n/index";
import medicinesClientService from "../../services/medicine-client/medicine-client.js";

export default {
  components: {
    MedicineClientCheckList,
  },
  data: () => ({
    hideList: false,
    editProccess: false,
    mun: {
      id: null,
      codGenZentria: "",
      descripcionGenericaZentria: "",
      codHomEvedisa: "",
      codigo: "",
      codBarras: "",
      descripcion: "",
      cum: "",
      undMinPresentacion: "",
      contenido: null,
      codBarrasEvedisa: "",
      pluCode: "",
      active: true,
    },
    update: 0,
    req32: [
      function (v) {
        return !!v || i18n.t("field-required");
      },
      function (v) {
        return String(v || "").length <= 32 || "Máximo 32 caracteres";
      },
    ],
    req512: [
      function (v) {
        return !!v || i18n.t("field-required");
      },
      function (v) {
        return String(v || "").length <= 512 || "Máximo 512 caracteres";
      },
    ],
    reqPlu16Digits: [
      function (v) {
        return !!v || i18n.t("field-required");
      },
      function (v) {
        return String(v || "").length <= 16 || "Máximo 16 dígitos";
      },
      function (v) {
        return /^\d+$/.test(String(v || "")) || "Solo números";
      },
    ],
    opt32: [
      function (v) {
        return String(v || "").length <= 32 || "Máximo 32 caracteres";
      },
    ],
    opt64: [
      function (v) {
        return String(v || "").length <= 64 || "Máximo 64 caracteres";
      },
    ],
    opt512: [
      function (v) {
        return String(v || "").length <= 512 || "Máximo 512 caracteres";
      },
    ],
    optDigits64: [
      function (v) {
        return String(v || "").length <= 64 || "Máximo 64 dígitos";
      },
      function (v) {
        return !v || /^\d+$/.test(String(v)) || "Solo números";
      },
    ],
    contenidoRules: [
      function (v) {
        return (
          v === null || v === "" || /^[0-9]+$/.test(String(v)) || "Solo números"
        );
      },
    ],
    loadingSaveButton: false,
    loadingDelete: false,
    showDelete: false,
    showIcon: false,
    dialog: false,
  }),

  methods: {
    handleMunicipio(item) {
      this.hideList = true;
      this.showIcon = false;

      this.mun.id = item.id;
      this.mun.codGenZentria = item.codGenZentria || "";
      this.mun.descripcionGenericaZentria =
        item.descripcionGenericaZentria || "";
      this.mun.codHomEvedisa = item.codHomEvedisa || "";
      this.mun.codigo = item.codigo || "";
      this.mun.codBarras = item.codBarras || "";
      this.mun.descripcion = item.descripcion || "";
      this.mun.cum = item.cum || "";
      this.mun.undMinPresentacion = item.undMinPresentacion || "";
      this.mun.contenido =
        item.contenido !== null && item.contenido !== undefined
          ? item.contenido
          : null;
      this.mun.codBarrasEvedisa = item.codBarrasEvedisa || "";
      this.mun.pluCode = item.pluCode || "";
      this.mun.active = !!item.active;

      this.editProccess = true;
      this.update = 1;
      this.loadingDelete = false;
      this.showDelete = true;
    },

    closeUser() {
      this.hideList = false;
      this.dialog = false;
      this.mun = {
        id: null,
        codGenZentria: "",
        descripcionGenericaZentria: "",
        codHomEvedisa: "",
        codigo: "",
        codBarras: "",
        descripcion: "",
        cum: "",
        undMinPresentacion: "",
        contenido: null,
        codBarrasEvedisa: "",
        pluCode: "",
        active: true,
      };
      this.showIcon = false;
      if (this.$refs.municipioform && this.$refs.municipioform.reset) {
        this.$refs.municipioform.reset();
      }
      this.editProccess = false;
      this.update = 0;
      this.showDelete = false;
    },

    async save() {
      if (!this.$refs.municipioform.validate()) {
        if (this.$notify) {
          this.$notify({
            group: "app",
            type: "error",
            text: i18n.t("app.error-required-fields"),
          });
        }
        return;
      }
      this.loadingSaveButton = true;
      try {
        var payload = { ...this.mun };
        var result = await medicinesClientService.create(payload);
        if (result && (result.status === 200 || result.status === 201)) {
          if (this.$notify) {
            this.$notify({
              group: "app",
              type: "success",
              text: i18n.t("record-successfully-created"),
            });
          }
        }
        if (this.$refs.municipioList && this.$refs.municipioList.searchCity) {
          this.$refs.municipioList.searchCity();
        }
        this.closeUser();
      } catch (err) {
        if (this.$notify) {
          this.$notify({
            group: "app",
            type: "error",
            text: i18n.t("app.unexpected-error"),
          });
        }
        throw err;
      } finally {
        this.loadingSaveButton = false;
      }
    },

    async updateMunicipio() {
      var id = this.mun.id;
      var data = { ...this.mun };
      try {
        var result = await medicinesClientService.update(id, data);
        if (result && result.status === 200) {
          if (this.$notify) {
            this.$notify({
              group: "app",
              type: "success",
              text: i18n.t("record-update"),
            });
          }
          if (this.$refs.municipioList && this.$refs.municipioList.searchCity) {
            this.$refs.municipioList.searchCity();
          }
          this.closeUser();
        }
      } catch (err) {
        if (this.$notify) {
          this.$notify({
            group: "app",
            type: "error",
            text: i18n.t("app.unexpected-error"),
          });
        }
        throw err;
      }
    },

    async deleteMunicipio() {
      var id = this.mun.id;
      this.loadingDelete = true;
      try {
        var result = await medicinesClientService.remove(id);
        if (result && result.status === 200) {
          if (this.$notify) {
            this.$notify({
              group: "app",
              type: "success",
              text: "Medicamento eliminado",
            });
          }
          if (this.$refs.municipioList && this.$refs.municipioList.searchCity) {
            this.$refs.municipioList.searchCity();
          }
          this.closeUser();
        }
      } catch (e) {
        this.showIcon = false;
        var code;
        var hasResp = e && e.response && e.response.data;
        if (hasResp && typeof hasResp.code !== "undefined") {
          code = hasResp.code;
        } else {
          code = e && e.code;
        }
        if (code === "The medicine has associated transactions") {
          if (this.$notify) {
            this.$notify({
              group: "app",
              type: "error",
              text: "El medicamento tiene transacciones; no se puede eliminar",
            });
          }
        } else {
          if (this.$notify) {
            this.$notify({
              group: "app",
              type: "error",
              text: i18n.t("app.unexpected-error"),
            });
          }
        }
      } finally {
        this.loadingDelete = false;
      }
    },
  },
};
